module.exports = __webpack_public_path__ + "img/bancoestado.d78b50b.png";